import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import AddCustomField from './AddCustomField';
// import ProductVariants from './ProductVariants/ProductVariants';
// import SizeVariant from './ProductVariants/SizeVariant';
// import ColorVariant from './ProductVariants/ColorVariant';

function Modal() {
    const activeModal = useSelector((state) => state.inventoryManagement.modal.activeModal);
    const displayModal = useSelector((state) => state.inventoryManagement.modal.displayModal);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'add-custom-field' && <AddCustomField />}

            {/* {activeModal === 'select-variant-type' && <ProductVariants />} */}

            {/* {activeModal === 'size-variant-form' && <SizeVariant />} */}

            {/* {activeModal === 'color-variant-form' && <ColorVariant />} */}
        </div>
    );
}

export default Modal;
